import { AdsProviderDashboard } from './ads-report/AdsProviderDashboard';

function GoogleAdsMark() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
      <rect x="9.2" y="1.5" width="5.6" height="20" rx="2.8" transform="rotate(30 12 11.5)" fill="#FBBC04" />
      <rect x="3.4" y="7" width="5.6" height="14" rx="2.8" transform="rotate(-30 6.2 14)" fill="#4285F4" />
      <circle cx="18.2" cy="18.6" r="2.9" fill="#34A853" />
    </svg>
  );
}

/** Google Ads campaigns, spend and conversions. */
export default function GoogleAdsPage() {
  return (
    <AdsProviderDashboard
      provider="google"
      title="Google Ads"
      subtitle="Search, Performance Max, YouTube and Display campaigns"
      icon={<GoogleAdsMark />}
      colors={{ primary: '#4285F4', secondary: '#34A853', palette: ['#4285F4', '#34A853', '#FBBC04', '#EA4335', '#9F7AEA', '#CBD5E1'] }}
      tone="sky"
    />
  );
}
